import { I18nProvider } from '@/i18n';
import AppProvider from '@/providers/AppProvider';
import CurrencyBootstrap from '@/providers/CurrencyBootstrap';
import { router } from '@/router';
import { bindRouter } from '@/router/navigate';
import { installChunkRecovery } from '@/utils/chunkRecovery';
import { startSessionKeepAlive } from '@/utils/sessionKeepAlive';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import './global.scss';
import './tailwind.css';

// 部署换版后，旧标签页里记着的 chunk 文件名在新产物里已经不存在，路由级 lazy
// 的 import() 会 404。拦住 Vite 的 preloadError 刷新到新版本，别让用户停在报错页。
// 必须赶在首屏渲染之前装好，否则首个页面 chunk 失败时轮不到它。
installChunkRecovery();

// 让拦截器等非组件代码也能跳转
bindRouter(router);

// 会话心跳：只在用户真有操作时续会话，人走了照常按空闲寿命过期
startSessionKeepAlive();

// I18nProvider 必须在 AppProvider 外层：它那层 ConfigProvider 才带语言包，
// 而 feedback.modal 用的是 AppProvider 里 <App> 提供的实例，弹层按钮文案跟随
// <App> 所在层的 ConfigProvider。反过来的话确认框按钮会掉回英文 Cancel/OK。
createRoot(document.getElementById('root')!).render(
  <CurrencyBootstrap>
    <I18nProvider>
      <AppProvider>
        <RouterProvider router={router} />
      </AppProvider>
    </I18nProvider>
  </CurrencyBootstrap>,
);
